import { render, staticRenderFns } from "./GbfsDatasets.vue?vue&type=template&id=315d64d8"
import script from "./GbfsDatasets.vue?vue&type=script&lang=js"
export * from "./GbfsDatasets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports